/**
 * @file Check calendar component
 * @author Maarten Lensink
 */
import * as tslib_1 from "tslib";
import { AfterViewInit } from '@angular/core';
import { EntityQuery, QueryOptions, FetchStrategy } from 'breeze-client';
import * as moment from 'moment';
import { OverlayProvider } from '../../ui/overlay-provider';
import { OverlayService } from '../../core/overlay.service';
import { LocalisationService } from '../../core/localisation.service';
import { ForecastService } from '../forecast.service';
import { AbstractBase } from '../../core/helpers/abstract-base';
/**
 * The component presents mismatches between the calendar and forecast data.
 * @export
 * @class CheckCalendarComponent
 * @implements {AfterViewInit}
 */
var CheckCalendarComponent = /** @class */ (function (_super) {
    tslib_1.__extends(CheckCalendarComponent, _super);
    /**
     * Creates an instance of CheckCalendarComponent.
     * @param {ForecastService} forecastService
     * @param {LocalisationService} localisationService
     * @param {OverlayService} overlayService
     * @param {OverlayProvider} overlayProvider
     * @memberOf CheckCalendarComponent
     */
    function CheckCalendarComponent(forecastService, localisationService, overlayService, overlayProvider) {
        var _this = _super.call(this) || this;
        _this.forecastService = forecastService;
        _this.localisationService = localisationService;
        _this.overlayService = overlayService;
        /**
         * The state is used for the template.
         * @memberOf CheckCalendarComponent
         */
        _this.state = 'loading';
        _this.function = overlayProvider.entity;
        return _this;
    }
    /**
     * Retrieves the mismatches between the calendar and the call data, if any.
     * @memberOf CheckCalendarComponent
     */
    CheckCalendarComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        var query = EntityQuery.from('CalendarAnomalies');
        query.parameters = { oid: this.function['Oid'] };
        query.queryOptions = new QueryOptions({ fetchStrategy: FetchStrategy.FromServer });
        this.forecastService.entityManager.executeQuery(query).then(function (response) {
            _this.items = response.results.slice(0, 25);
            _this.state = _this.items.length === 0 ? 'noErrors' : 'hasErrors';
        });
    };
    /**
     * Returns a string representation of the date parameter.
     * @param {Date} date The date is converted to a string.
     * @returns {string} The localised date.
     * @memberOf CheckCalendarComponent
     */
    CheckCalendarComponent.prototype.dateToString = function (date) {
        return moment(date).format(this.localisationService.currentLanguage.formats.date.format);
    };
    /**
     * Closes the overlay.
     * @memberOf CheckCalendarComponent
     */
    CheckCalendarComponent.prototype.close = function ($event) {
        this.overlayService.closeOverlay();
    };
    return CheckCalendarComponent;
}(AbstractBase));
export { CheckCalendarComponent };
